import React from "react";
import { Palette, Download, Trash2 } from "lucide-react";
import { toast } from "sonner";

const DESIGNS = [
  { id: "D-1", name: "Visiting cards final.pdf", fmt: "PDF", at: "Feb 10, 2026", img: "https://images.unsplash.com/photo-1623305463957-df17547327cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=400" },
  { id: "D-2", name: "Wedding invite.ai", fmt: "AI", at: "Feb 03, 2026", img: "https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&q=85&w=400" },
  { id: "D-3", name: "Product packaging.psd", fmt: "PSD", at: "Jan 24, 2026", img: "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?crop=entropy&cs=srgb&fm=jpg&q=85&w=400" },
];

export default function CustomerDesigns() {
  return (
    <div data-testid="customer-designs">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-3xl font-bold">Saved Designs</h1>
        <button onClick={() => toast.success("Upload flow opened")} className="btn-offset inline-flex items-center gap-1 rounded-md bg-lime-400 px-4 py-2 text-sm font-bold text-neutral-950 hover:bg-lime-300" data-testid="designs-upload"><Palette size={14} /> Upload</button>
      </div>
      <div className="mt-4 grid gap-4 md:grid-cols-3">
        {DESIGNS.map((d) => (
          <div key={d.id} className="rounded-lg border border-neutral-200 bg-white" data-testid={`design-${d.id}`}>
            <img src={d.img} alt="" className="aspect-[4/3] w-full rounded-t-lg object-cover" />
            <div className="p-3">
              <div className="text-xs uppercase tracking-widest text-neutral-500">{d.fmt} · {d.at}</div>
              <div className="mt-1 truncate font-semibold">{d.name}</div>
              <div className="mt-2 flex gap-2">
                <button onClick={() => toast.success("Downloaded")} className="inline-flex items-center gap-1 rounded-md border border-neutral-300 px-2 py-1 text-xs font-semibold hover:border-neutral-900" data-testid={`design-download-${d.id}`}><Download size={12} /> Download</button>
                <button onClick={() => toast.success("Reorder started")} className="rounded-md border border-neutral-300 px-2 py-1 text-xs font-semibold hover:border-neutral-900" data-testid={`design-reorder-${d.id}`}>Reorder</button>
                <button onClick={() => toast.success("Deleted")} className="ml-auto rounded-md border border-neutral-300 p-1 text-neutral-500 hover:border-red-400 hover:text-red-500" data-testid={`design-delete-${d.id}`}><Trash2 size={12} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
